import { useEffect, useState } from 'react'
import dayjs from 'dayjs'

const REFRESH_INTERVAL_MS = 30000
const MINUTES_IN_HOUR = 60

const formatTimeRemaining = (minutesRemaining: number) => {
  if (minutesRemaining <= MINUTES_IN_HOUR) {
    return `${minutesRemaining} min`
  }

  return `${Math.ceil(minutesRemaining / MINUTES_IN_HOUR)}h`
}

export const useResendInviteCooldown = (resendAvailableAt: string | null) => {
  const [availableAt, setAvailableAt] = useState(resendAvailableAt)
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    setAvailableAt(resendAvailableAt)
  }, [resendAvailableAt])

  const availableAtMs = availableAt ? dayjs(availableAt).valueOf() : null
  const isDisabled = availableAtMs !== null && availableAtMs > now

  useEffect(() => {
    if (!isDisabled) {
      return
    }

    setNow(Date.now())

    const intervalId = setInterval(() => {
      setNow(Date.now())
    }, REFRESH_INTERVAL_MS)

    return () => {
      clearInterval(intervalId)
    }
  }, [isDisabled])

  const minutesRemaining =
    isDisabled && availableAtMs !== null
      ? Math.max(1, Math.ceil(dayjs(availableAtMs).diff(now, 'minute', true)))
      : null

  return {
    isDisabled,
    timeRemaining: minutesRemaining === null ? null : formatTimeRemaining(minutesRemaining),
    isLimitReached: minutesRemaining !== null && minutesRemaining > MINUTES_IN_HOUR,
    setResendAvailableAt: setAvailableAt,
  }
}
